import { mlyApi, getHeaders } from "config/mlyApi";
import { getUrlQueryString } from "utils/getUrlQueryString";

export async function getDemographicById(demographicId: number, pageNum?: number, limit?: number) {
  const requestConfig = await getHeaders();
  const baseUrl = `/demographics/${demographicId}`;
  const url = baseUrl + getUrlQueryString({ page: pageNum, limit });
  return mlyApi.get(url, requestConfig);
}
